/** Shared Self Referred / add-patient constants (safe for client + server). */
export const SELF_REFERRED_FEATURE_LABEL = 'Self Referred';
export const SELF_REFERRED_SOURCE_LABEL = 'Manual / Self Referred Patient';
export const SYSTEM_REFERRAL_EMAIL = 'system@toothreferral.com';
export const SYSTEM_REFERRAL_USER_ID = 'system-user-placeholder';

/** Add-patient referring source choice (outside office vs patient self-referral). */
export const ADD_PATIENT_REFERRING_SOURCE = {
  DOCTORS_OFFICE: 'doctors_office',
  SELF_REFERRAL: 'self_referral',
} as const;

export type AddPatientReferringSourceType =
  (typeof ADD_PATIENT_REFERRING_SOURCE)[keyof typeof ADD_PATIENT_REFERRING_SOURCE];

export function isDoctorsOfficeReferringSource(
  value: string | null | undefined
): value is typeof ADD_PATIENT_REFERRING_SOURCE.DOCTORS_OFFICE {
  return value === ADD_PATIENT_REFERRING_SOURCE.DOCTORS_OFFICE;
}

/** True when a referral was created via the Self Referred / add-patient intake flow. */
export function isSelfReferredReferral(referral: {
  isEmbedded?: boolean | null;
  referringDoctor?: unknown;
}): boolean {
  if (referral.isEmbedded) return false;
  const doctor = referral.referringDoctor as
    | { email?: string | null; userId?: string | null }
    | null
    | undefined;
  const email = doctor?.email;
  const userId = doctor?.userId;
  return email === SYSTEM_REFERRAL_EMAIL || userId === SYSTEM_REFERRAL_USER_ID;
}
